import { render, staticRenderFns } from "./NoshiIcon.vue?vue&type=template&id=1d8b7214&lang=pug&"
import script from "./NoshiIcon.vue?vue&type=script&lang=js&"
export * from "./NoshiIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports